export default __webpack_public_path__ + "static/media/google-cloud.c1d23b77.png";